import { z } from 'zod'
import type { DefaultValues } from 'react-hook-form'

export const createTransactionSchema = z.object({
	invoiceId:     z.string().min(1, 'finances.transactionDialog.errors.invoiceRequired'),
	amount:        z.coerce.number().positive('finances.transactionDialog.errors.amountPositive'),
	paymentMethod: z.enum(['KASSA', 'CASH', 'BANK_TRANSFER', 'CARD']),
	externalRef:   z.string().trim().optional(),
})

export type CreateTransactionFormValues = z.infer<typeof createTransactionSchema>

export const DEFAULT_VALUES: DefaultValues<CreateTransactionFormValues> = {
	invoiceId:     '',
	amount:        undefined,
	paymentMethod: 'BANK_TRANSFER',
	externalRef:   '',
}
